import React from 'react';

export const History = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--history';
  color = color || '#0076CC';

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <g clipPath="url(#clip0_13415_1339)">
        <path
          d="M3.5 4.5625C3.5 4.28071 3.61194 4.01046 3.8112 3.8112C4.01046 3.61194 4.28071 3.5 4.5625 3.5H19.4375C19.7193 3.5 19.9895 3.61194 20.1888 3.8112C20.3881 4.01046 20.5 4.28071 20.5 4.5625V19.4375C20.5 19.7193 20.3881 19.9895 20.1888 20.1888C19.9895 20.3881 19.7193 20.5 19.4375 20.5H4.5625C4.28071 20.5 4.01046 20.3881 3.8112 20.1888C3.61194 19.9895 3.5 19.7193 3.5 19.4375V4.5625Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 7.75H20.5"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 3.5V7.75"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14.125C8 15.1859 8.42143 16.2033 9.17157 16.9534C9.92172 17.7036 10.9391 18.125 12 18.125C13.0609 18.125 14.0783 17.7036 14.8284 16.9534C15.5786 16.2033 16 15.1859 16 14.125C16 13.0641 15.5786 12.0467 14.8284 11.2966C14.0783 10.5464 13.0609 10.125 12 10.125C10.9391 10.125 9.92172 10.5464 9.17157 11.2966C8.42143 12.0467 8 13.0641 8 14.125Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12.6211V14.1251L13 15.1251"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13415_1339">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default History;
